<div class="container">
  <div class="section">
    <p class="section-name">Resumen</p>
    <div class="overview">
      <div class="overview-item">
        <p class="title">Nombre del producto/servicio</p>
        <p class="content">{{ data.charge.metadata.items[0]?.name || '(Sin nombre)' }}</p>
      </div>
      <div class="overview-item">
        <p class="title">Total a pagar</p>
        <p class="content amount">
          {{
            +data.charge.price?.amount || 0
              | currency: data.charge.price?.currency.replace('S', '$')
          }}
        </p>
      </div>
    </div>
  </div>
  <div class="section">
    <p class="section-name">Link de pago</p>
    <div class="payment-url">
      <div class="url">{{ data.charge.hosted_url }}</div>
      <button (click)="copyUrl()" class="copy">
        <img *ngIf="!successCopy" src="assets/icons/news/copy_violet.svg" />
        <img *ngIf="successCopy" class="success" src="assets/icons/checked-onboarding.svg" />
      </button>
    </div>
  </div>
  <div class="footer-section">
    <p class="remain-time">Expira en: {{ getRemainTime() }}</p>
    <button class="td-btn primary" (click)="close()">Finalizar</button>
  </div>
</div>
